import { useQuery, useQueryClient } from "@tanstack/react-query";
import { SportsCard } from "models/cards";
import { CustomerPackage } from "models/packages";
import { useAuthenticatedRequest } from "./useRequests";

const QUERY_KEY = "customerDashboard";

type CustomerDashboardInfo = {
    processingPackagesCount: number;
    latestPackages: CustomerPackage[];
    latestCards: SportsCard[];
};

const useCustomerDashboard = () => {
    const getData = useAuthenticatedRequest<CustomerDashboardInfo>({
        url: "/dashboard/customer",
        method: "GET",
    });

    return useQuery(["customerDashboard"], getData);
};

export const useInvalidateCustomerDashboard = (accountId?: string | null) => {
    const queryClient = useQueryClient();
    return () => {
        queryClient.invalidateQueries([QUERY_KEY]);
    };
};

export default useCustomerDashboard;
